import styled from "styled-components";
import { BLACK, GRAY, RUBIK, WHITE } from "../../index.style.ts";

export const MonthlyWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin: 30px 0;
  flex-direction: column;
`;

export const Title = styled.h2`
  text-transform: capitalize;
  margin: 0;
  font-family: ${RUBIK};
  display: flex;
  align-items: center;
  gap: 8px;

  @media only screen and (max-width: 800px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ItemContainer = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;

  @media only screen and (max-width: 800px) {
    justify-content: center;
  }

  .itemWrapper {
    .inputWrapper {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
  }

  input:not(:disabled) {
    width: 120px !important;
  }
`;

export const ItemWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
`;

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  flex-direction: column;
`;

export const Selectors = styled.div`
  display: flex;
  gap: 25px;

  .tooltip {
    width: 150px;
  }
`;

export const FilterLink = styled.div`
  display: flex;
  gap: 4px;

  a.text {
    color: ${BLACK};
    align-items: flex-start;
    font-weight: 600;
    height: 25px;
  }
`;

export const AddBtn = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    text-transform: capitalize;
    font-size: 18px !important;
    width: 180px !important;
  }
`;

export const ModalBtn = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`;

export const BudgetOptions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  button {
    box-shadow: -5px 5px 5px ${GRAY};
    background: ${WHITE} !important;
    border-radius: 10px !important;
    padding: 5px 10px 5px 5px !important;
  }
`;
